import React, {memo} from 'react';
import PropTypes from 'prop-types';
import FaqLayout from 'cms/faqs/FaqLayout';
import ArticleCard from 'cms/helpers/ArticleCard';

const Page = ({breadcrump, title, content, categories, articles, translations}) => (
  <FaqLayout breadcrump={breadcrump} categories={categories} translations={translations}>
    <>
      <h1 className="display-3 font-light mb-3" dangerouslySetInnerHTML={{__html: title}} />
      <div dangerouslySetInnerHTML={{__html: content}} />
      {
        articles.map(({ID, post_title, post_content, permanlink}) =>
          <ArticleCard
            key={ID}
            postTitle={post_title}
            postContent={post_content}
            permanlink={permanlink}
            translations={translations}
          />
        )
      }
    </>
  </FaqLayout>
);

Page.propTypes = {
  breadcrump: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  categories: PropTypes.array.isRequired,
  articles: PropTypes.array.isRequired,
  translations: PropTypes.shape({
    sidebarLabel: PropTypes.string.isRequired,
    placeholderSearch: PropTypes.string.isRequired,
    readMore: PropTypes.string.isRequired
  }).isRequired
};

export default memo(Page);
